module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1dDbd"))).then(() => parcelRequire('2KbAe'));